import type { Settings } from '@ais-ui/websockets';
import type { CollectionTranslator, RadarOverlayItem } from '../types';

/**
 * Translator for the `radar_overlays` collection. Maps the legacy blob's
 * top-level `radarSettings[]` array to/from the clean item shape. This is a pure
 * pass-through (the backend item mirrors the legacy shape exactly), including
 * `opacity`.
 */
export const radarOverlaysTranslator: CollectionTranslator<RadarOverlayItem> = {
  fromBlob(blob: Settings): RadarOverlayItem[] {
    const overlays = (blob as unknown as Record<string, unknown>).radarSettings;
    if (!Array.isArray(overlays)) return [];
    return overlays.map((overlay) => {
      const o = overlay as Record<string, unknown>;
      return {
        id: String(o.id ?? ''),
        name: (o.name as string) ?? '',
        url: (o.url as string) ?? '',
        enabled: o.enabled !== false,
        opacity: typeof o.opacity === 'number' ? o.opacity : 1,
      };
    });
  },

  applyToBlob(blob: Settings, items: RadarOverlayItem[]): Settings {
    return {
      ...(blob as unknown as Record<string, unknown>),
      radarSettings: items,
    } as unknown as Settings;
  },
};
